'use strict';

var ChangePasswordController = require('./ChangePasswordController');

angular
	.module('settings.changePassword', [])
	.controller('ChangePasswordController', ChangePasswordController);


// WEBPACK FOOTER //
// ./src/app/settings/changePassword/index.js